<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">
                        {{ $route.params.id ? "Edit Delegation" : "New Delegation" }}
                    </h3>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Ongoing Delegation -->
        <template v-if="isManager && ongoingDelegations.length">
            <div class="row mb-5">
                <div class="col-md-12">
                    <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
                        <table class="table table-bordered custom-table mb-0">
                            <thead class="thead-light">
                                <tr>
                                    <th colspan="5" class="text-center">Ongoing Delegations</th>
                                </tr>
                                <tr>
                                    <th>Delegator</th>
                                    <th>Delegatee</th>
                                    <th>Date Start</th>
                                    <th>Date End</th>
                                    <th>Workflow Types</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in ongoingDelegations" :key="item.Id">
                                    <td>{{ item.Delegator }}</td>
                                    <td>{{ item.Delegatee }}</td>
                                    <td>{{ item.DateStartDisplay }}</td>
                                    <td>{{ item.DateEndDisplay }}</td>
                                    <td>{{ item.WorkflowTypesDisplay }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </template>
        <!-- /Ongoing Delegation -->

        <!-- Form -->
        <form @submit.prevent="save">
            <div class="form-group row align-items-center">
                <label class="col-md-2 mb-0">Delegator</label>
                <div class="col-md-6 pl-md-0">
                    <Select2 v-model="delegatorId" :options="delegators" required :disabled="isManager" />
                </div>
            </div>
            <div class="form-group row align-items-center">
                <label class="col-md-2 mb-0">Delegatee</label>
                <div class="col-md-6 pl-md-0">
                    <Select2 v-model="delegateeId" :options="delegatees" required />
                </div>
            </div>
            <div class="form-group row align-items-center">
                <label class="col-md-2 mb-0">Date Start</label>
                <div class="col-md-6 pl-md-0">
                    <input type="date" class="form-control" required v-model="dateStart" :min="todayDate" />
                </div>
            </div>
            <div class="form-group row align-items-center">
                <label class="col-md-2 mb-0">Date End</label>
                <div class="col-md-6 pl-md-0">
                    <input type="date" class="form-control" v-model="dateEnd" :min="todayDate" />
                </div>
            </div>
            <div class="form-group row align-items-center">
                <label class="col-md-2 mb-0">Workflow Types</label>
                <div class="col-md-6 pl-md-0 pt-2">
                    <template v-if="delegatorCompany.toLowerCase() == sgCompany.toLowerCase()">
                        <input type="checkbox" v-model="workflowTypes" value="Car Park Claims" id="Car Park Claim" />
                        <label for="Car Park Claim" class="mr-4">Car Park Claims</label>
                    </template>
                    <input type="checkbox" v-model="workflowTypes" value="Timesheet" id="Timesheet" />
                    <label for="Timesheet">Timesheet</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2">
                    <button type="button" class="btn btn-secondary" @click="$router.go(-1)">
                        <i class="fa fa-reply mr-2"></i>Back
                    </button>
                </div>
                <div class="col-md-6 text-right">
                    <button type="submit" class="btn btn-primary">
                        <i v-if="$route.params.id" class="fa fa-save"></i>
                        <i v-else class="fa fa-plus"></i>
                        {{ $route.params.id ? "Save" : "Add" }}
                    </button>
                </div>
            </div>
        </form>
        <!-- /Form -->
    </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
import Select2 from "v-select2-component";

export default {
    components: { Select2 },
    data() {
        return {
            ongoingDelegations: [],
            delegators: [],
            delegatees: [],
            dateStart: "",
            dateEnd: "",
            workflowTypes: [],
            delegatorId: "",
            delegateeId: "",
            delegatorCompany: "",
            sgCompany: config.DEFAULT_COMPANY
        }
    },

    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
        isManager() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.IsManager;
        },
        todayDate() {
            let currentDate = new Date();
            return currentDate.getFullYear() + "-" + (currentDate.getMonth() + 1).toString().padStart(2, "0") + "-" + currentDate.getDate()
        }
    },

    watch: {
        delegatorId(val) {
            // console.log("delegator company: " + this.delegatorCompany);
            // console.log(this.delegators);

            if ( this.role == "admin" ) {

                if (!val) this.delegatorCompany = "";
                this.workflowTypes = [];
                let delegator = this.delegators.find(c => c.id == val);
                this.delegatorCompany = delegator ? delegator.company : "";
            }

            // console.log(this.delegatorCompany);
        }
    },

    methods: {
        getOngoingDelegations() {
            let param = {
                Token: this.token
            }
            this.$store.state.isLoading = true;
            API.getOngoingDelegations(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.ongoingDelegations = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getDelegationDetail() {
            let param = {
                Token: this.token,
                Id: this.$route.params.id,
            };
            this.$store.state.isLoading = true;
            API.getDelegationDetail(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        if (response.data.record) {
                            let data = response.data.record;
                            this.delegatorId = data.DelegatorId;
                            this.delegateeId = data.DelegateeId;
                            this.dateStart = data.DateStart;
                            this.dateEnd = data.DateEnd;
                            this.workflowTypes = data.WorkflowTypes;
                        } else {
                            this.$router.replace({ name: "delegationList" });
                        }
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getDelegators() {
            let param = { Token: this.token };
            this.$store.state.isLoading = true;
            API.getDelegators(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.delegators = response.data.record;

                        if ( this.role == "employee" ) {
                            this.delegatorId = this.delegators[0].id;
                        }
                        // console.log("get delegators");
                        // console.log(this.delegators);
                        // console.log(this.delegatorId);
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getDelegatees() {
            let param = { Token: this.token };
            this.$store.state.isLoading = true;
            API.getDelegatees(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.delegatees = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        save() {
            //validation for date 
            if (this.dateEnd) {
                let dateStart = new Date(this.dateStart);
                let dateEnd = new Date(this.dateEnd);
                if (dateStart > dateEnd) {
                    alert("Date Start cannot be greater than Date End.");
                    return;
                }
            }
            //validation for worktype
            if (!this.workflowTypes || !this.workflowTypes.length) {
                alert("Please select at least one workflow type.");
                return;
            }
            //validation for delegatee and delegator
            if (this.delegatorId == this.delegateeId) {
                alert("Delegatee cannot be the same as Delegator.");
                return;
            }
            //validation for overlap
            let ongoingDelegations = [...this.ongoingDelegations];
            if (this.$route.params.id) {
                let editId = this.$route.params.id.toLowerCase();
                let indexToRemove = ongoingDelegations.findIndex(c => c.Id == editId);
                ongoingDelegations.splice(indexToRemove, 1);
            }
            if (ongoingDelegations.length) {
                let messages = [];
                for (let rec of ongoingDelegations) {
                    let ongoingWorkflowTypes = rec.WorkflowTypesDisplay;
                    let workflowTypes = this.workflowTypes.join(", ");
                    if (rec.DelegatorId == this.delegatorId && rec.DelegateeId == this.delegateeId &&
                        (ongoingWorkflowTypes.indexOf(workflowTypes) >= 0 || workflowTypes.indexOf(ongoingWorkflowTypes) >= 0)) {
                        if (!rec.DateEndCalendar) {
                            messages.push(`Delegator: ${rec.Delegator}|Delegatee: ${rec.Delegatee}|Date Start: ${rec.DateStartDisplay}|Date End: ${rec.DateEndDisplay}|Workflow Types: ${rec.WorkflowTypesDisplay}`);
                        } else {
                            let ongoingDateStart = new Date(rec.DateStartCalendar);
                            let ongoingDateEnd = new Date(rec.DateEndCalendar);
                            let dateStart = new Date(this.dateStart);
                            let dateEnd = new Date(this.dateEnd);
                            if ((dateStart >= ongoingDateStart && dateStart <= ongoingDateEnd) || (dateEnd >= ongoingDateStart && dateEnd <= ongoingDateEnd)
                                || (ongoingDateStart >= dateStart && ongoingDateStart <= dateEnd) || (ongoingDateEnd >= dateStart && ongoingDateEnd <= dateEnd)) {
                                messages.push(`Delegator: ${rec.Delegator}|Delegatee: ${rec.Delegatee}|Date Start: ${rec.DateStartDisplay}|Date End: ${rec.DateEndDisplay}|Workflow Types: ${rec.WorkflowTypesDisplay}`);
                            }
                        }
                    }
                }
                if (messages.length) {
                    alert("The added/updated delegation overlaps with below existing ongoing delegations:\n\n" + messages.join("\n\n"));
                    return;
                }
            }
            //saving
            let param = {
                Token: this.token,
                Id: this.$route.params.id,
                DelegatorId: this.delegatorId,
                DelegateeId: this.delegateeId,
                DateStartInput: this.dateStart,
                DateEndInput: this.dateEnd,
                WorkflowTypes: this.workflowTypes
            };
            this.$swal({
                title: "Are you sure?",
                text: "Are you sure you want to save the delegation?",
                icon: "info",
                buttons: true,
                dangerMode: false,
            }).then((willSave) => {
                if (willSave) {
                    this.$store.state.isLoading = true;
                    API.saveDelegation(param)
                        .then((response) => {
                            this.$store.state.isLoading = false;
                            this.$swal(response.data.message, {
                                icon: response.data.success ? "success" : "error",
                            });
                            if (response.data.success) {
                                this.$router.replace({ name: "delegationList" });
                            }
                        })
                        .catch((error) => {
                            this.$store.state.isLoading = false;
                            this.$swal(error.response.data.Message, { icon: "error" });
                        });
                }
            });
        }
    },

    created() {
        this.getOngoingDelegations();
        this.getDelegators();
        this.getDelegatees();
        if (this.$route.params.id) this.getDelegationDetail()
        if (this.isManager) {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            this.delegatorCompany = data.Company;
            this.delegatorId = data.Id;
        }
        //access control
        if (this.role != "admin" && !this.isManager)
            this.$router.replace({ name: "home" });
    }

}
</script>


// WEBPACK FOOTER //
// src/components/System/Delegation/DelegationEdit.vue